import { useEffect, useMemo } from 'react';

import {
  useWidgetLinksStore,
  WidgetLink,
} from '@/common/stores/useWidgetLinksStore';

export const useWidgetLinks = (
  sourceType: string,
  sourceId: string,
): WidgetLink[] => {
  const links = useWidgetLinksStore((state) => state.links);
  const fetchLinks = useWidgetLinksStore((state) => state.fetchLinks);

  const linkedItems = useMemo(
    () =>
      links.filter(
        (l) => l.source_type === sourceType && l.source_id === sourceId,
      ),
    [links, sourceType, sourceId],
  );

  useEffect(() => {
    fetchLinks();
  }, [fetchLinks]);

  return linkedItems;
};
